import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
  const parseQueryParams = (params) => {
    const obj = {};
    params.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  };

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return parseQueryParams(params);
};
